module.exports = __webpack_public_path__ + "static/media/smile3.c06b35b6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/smileImg/smile3.png
// module id = 76
// module chunks = 0